import React from "react";

import './styles.scss';

const UIButton = ({
    type = 'button',
    size = '',
    color = '',
    style = '',
    disabled = false,
    fullWidth,
    children,
    customStyles,
    onClick = () => {},
}) => {
    return (
        <button
            type={type}
            disabled={disabled}
            className={`ui-button ${color} ${size} ${style} ${fullWidth ? "full-width" : ""}`}
            style={customStyles}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export default UIButton;
